import shortid from "shortid";


export const  BRANDKIT_BUTTON_COMPONENT= () => {
  return {
    id: shortid(),
    name: "Untitled",
    entityType: "palette_component",
    order: 1,
    newComponent: true,
    draft: {
      widgets: [
        {
          type: "cleverstory.v2.widgets.button",
          name: "Untitled",
          properties: {
            desktop: {
              visible: true,
              layout: {
                width: "130px",
                height: "41px",
              },
              regular: {
                font: {
                  style: {
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  fontSize: "14",
                  fontFamily: null,
                  lineSpacing: null,
                  letterSpacing: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                },
                background: {
                  type: "solid",
                  r: 33,
                  g: 33,
                  b: 33,
                  a: 1,
                },
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                shadow: {
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  axes: {
                    x: "0",
                    y: "0",
                    b: "0",
                  },
                  show: false,
                },
              },
              hover: {
                font: {
                  style: {
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  fontSize: "14",
                  fontFamily: null,
                  lineSpacing: null,
                  letterSpacing: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                },
                background: {
                  type: "solid",
                  r: 33,
                  g: 33,
                  b: 33,
                  a: 1,
                },
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                shadow: {
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  axes: {
                    x: "0",
                    y: "0",
                    b: "0",
                  },
                  show: false,
                },
              },
              alignment: null,
              animation: null,
            },
            mobile: {
              visible: true,
              layout: {
                width: "130px",
                height: "41px",
              },
              regular: {
                font: {
                  style: {
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  fontSize: "14",
                  fontFamily: null,
                  lineSpacing: null,
                  letterSpacing: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                },
                background: {
                  type: "solid",
                  r: 33,
                  g: 33,
                  b: 33,
                  a: 1,
                },
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                shadow: {
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  axes: {
                    x: "0",
                    y: "0",
                    b: "0",
                  },
                  show: false,
                },
              },
              hover: {
                font: {
                  style: {
                    bold: false,
                    italic: false,
                    underline: false,
                  },
                  fontSize: "14",
                  fontFamily: null,
                  lineSpacing: null,
                  letterSpacing: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                },
                background: {
                  type: "solid",
                  r: 33,
                  g: 33,
                  b: 33,
                  a: 1,
                },
                border: {
                  sides: null,
                  color: {
                    type: "solid",
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1,
                  },
                  width: "0",
                  radius: {
                    lock: false,
                    topLeft: "0",
                    topRight: "0",
                    bottomLeft: "0",
                    bottomRight: "0",
                  },
                },
                shadow: null,
              },
              alignment: null,
              animation: null,
            },
          },
          uid: `widget_${shortid()}`,
          content: "Button Text",
        },
      ],
      fonts: null,
    },
  };
};

